import { useState, useEffect, forwardRef, useLayoutEffect } from 'react';
import NewsHeadline from './NewsHeadlines';
import './NewsList.css';
import { NewsHeadlineType } from '../../types/news.type';
import Pagination from '../Common/Pagination/Pagination';
import { paginate, getMaxPageNum } from '../../utils/pagination';
import React from 'react';
import { CommonTooltipType } from '../../types/common.type';

interface NewsListProps {
  displayedItems: NewsHeadlineType[];
  totalPages: number;
  page: number;
  setPage: (page: number) => void;
  touch: boolean;
  tooltipRef: React.RefObject<HTMLDivElement>;
  setTooltip: (tooltip: CommonTooltipType) => void;
  selectNewsStory?: (nid: string) => void;
  isSmallScreen?: boolean;
  setRef?: any;
  widgetRef?: any;
  hidePagination?: boolean;
  isLast?: boolean;
}

const NewsList = forwardRef(
  (
    {
      displayedItems,
      totalPages,
      selectNewsStory,
      isSmallScreen,
      setRef,
      page,
      setPage,
      touch,
      tooltipRef,
      setTooltip,
      widgetRef,
      hidePagination,
      isLast,
    }: NewsListProps,
    ref,
  ) => {
    const [maxPageNum, setMaxPageNum] = useState(
      getMaxPageNum(window.innerWidth, true, false, false),
    );

    useLayoutEffect(() => {
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => {
        window.removeEventListener('resize', updateSize);
      };
    }, []);

    useEffect(() => {
      if (widgetRef.current) {
        updateSize();
      }
    }, [widgetRef]);

    const updateSize = () => {
      const width = widgetRef.current
        ? widgetRef.current.getBoundingClientRect().width
        : window.innerWidth;
      setMaxPageNum(getMaxPageNum(width, true, false, false));
    };

    return displayedItems.length > 0 ? (
      <div className="fullNews-content-list-container">
        <div
          ref={ref as React.RefObject<HTMLDivElement>}
          className="fullNews-content-list"
        >
          {displayedItems.map((n: NewsHeadlineType, index: number) => {
            return (
              <NewsHeadline
                setRef={index === 0 ? setRef : null}
                key={index}
                nid={n.newsId}
                headline={n.headline}
                date={n.date}
                time={n.time}
                callback={selectNewsStory}
                isSmallScreen={isSmallScreen}
                touch={touch}
                tooltipRef={tooltipRef}
                setTooltip={setTooltip}
              />
            );
          })}
        </div>
        <div
          className="pagination"
          style={{ display: hidePagination ? 'none' : 'block' }}
        >
          <Pagination
            pagination={paginate(page, 1, totalPages, maxPageNum)}
            onPageClick={(targetPage: number) => {
              setPage(targetPage);
            }}
            haveLastPage={isLast}
          />
        </div>
      </div>
    ) : (
      <div className="fullNews-content-list">
        <div className="empty" />
      </div>
    );
  },
);

export default NewsList;
